import { render, staticRenderFns } from "./AppExpandableSection.vue?vue&type=template&id=1bf0c29a&scoped=true&"
import script from "./AppExpandableSection.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AppExpandableSection.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AppExpandableSection.vue?vue&type=style&index=0&id=1bf0c29a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf0c29a",
  null
  
)

export default component.exports